import { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLogout } from '../../hooks/useLogout';

import "./style.css"

import icon_request from '../../assets/friend_request.svg';
import icon_request_w from '../../assets/friend_request_w.svg';

function Nav() {
    const logout = useLogout();

    const navRef = useRef(null);
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);

    const status = useSelector(state => state.profil.status);
    const request = useSelector(state => state.profil.accessRequest);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (!isOpen) return;

            if (navRef.current && !navRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("click", handleClickOutside);

        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [isOpen]);

    const isActif = (path) => {
        return location.pathname === `/${path}` ? "actif" : "";
    }

    return (
        <nav className={isOpen ? 'open' : ''}>
            {!isOpen && (
                <button
                    className='open_nav'
                    onClick={(e) => {
                        e.stopPropagation();
                        setIsOpen(true);
                    }}
                >
                    <i className="fas fa-bars-staggered"></i>
                </button>
            )}

            <ul ref={navRef}>
                <h3>Menu</h3>

                {status === 'admin' &&
                    <li className={isActif('wlist')}>
                        <Link to="wlist" onClick={() => setIsOpen(false)}>- Email autorisé</Link>
                    </li>
                }
                <li className={isActif('')}>
                    <Link to="" onClick={() => setIsOpen(false)}>- Rechercher</Link>
                </li>
                <li className={isActif('profil')}>
                    <Link to="profil" onClick={() => setIsOpen(false)}>- Mon profil</Link>
                </li>
                <li className={isActif('access')}>
                    <Link to="access" onClick={() => setIsOpen(false)}>- Accessibilité</Link>
                    {request && request.length !== 0 && <img src={!isActif('access') ? icon_request : icon_request_w} alt="" />}
                </li>
                <li className={isActif('meeting')}>
                    <Link to="meeting" onClick={() => setIsOpen(false)}>- Réunions</Link>
                </li>
                <li>
                    <button onClick={() => logout()}>- Se déconnecter</button>
                </li>

                <li className="close_nav">
                    <button onClick={() => setIsOpen(false)}>Fermer</button>
                </li>
            </ul>
        </nav>
    )
}

export default Nav;